<div class="internal-resources-modal"
     id="internal-resources-container">
  <pop-loading *ngIf="isLoading">
  </pop-loading>

  <div class="internal-resources-dialog">
    <div class="dialog-title"
         translate="TOOLBAR.INTERNAL_RESOURCES"></div>
    <div class="custom-internal-resources-table">
      <p-table #dt
               [globalFilterFields]="[
          'internalResource.code',
          'internalResource.description'
        ]"
               [value]="internalResourceVMs"
               [scrollable]="true">
        <ng-template pTemplate="caption">
          <div class="pop-display-flex search-box">
            <i class="far fa-search"></i>
            <input type="text"
                   pInputText
                   size="50"
                   (input)="filterTable(dt, $event.target)"
                   class="input-filter" />

            <div class="filters"
                 *ngIf="isFilteredByInternalResourceGroup || isFilteredByInternalResourceFeeMethod">
              {{ 'MODAL.ACTIVE_FILTERS' | translate }}:
              <span class="filter"
                    *ngIf="isFilteredByInternalResourceGroup"
                    [matTooltip]="'TOOLTIP.INTERNAL_RESOURCE_GROUP_FILTER' | translate: { code: currentEstimate.internalResourceGroup?.code, description: currentEstimate.internalResourceGroup?.description }"
                    translate="MODAL.INTERNAL_RESOURCE_GROUP_FILTER"></span>

              <span class="filter"
                    *ngIf="isFilteredByInternalResourceFeeMethod"
                    [class.error]="!currentEstimate.internalFeeBillingMethodCode"
                    [matTooltip]="currentEstimate.internalFeeBillingMethodCode ? ('TOOLTIP.INTERNAL_RESOURCE_BILLING_METHOD_FILTER' | translate: { code: currentEstimate.internalFeeBillingMethodCode }) : ('ERROR.NO_METHOD' | translate)"
                    translate="MODAL.INTERNAL_RESOURCE_BILLING_METHOD_FILTER"></span>
            </div>
          </div>

        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th class="checkbox-header"></th>
            <th translate="MODAL.CODE"></th>
            <th translate="MODAL.DESC"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body"
                     let-editing="editing"
                     let-internalResourceVM>
          <tr [pSelectableRow]="internalResourceVM"
              [pEditableRow]="internalResourceVM">
            <td class="checkbox-col"
                [class.read-only]="
                currentEstimate.status !== 'New' || isGroupApproved
              ">
              <input #internalResourceInput
                     type="checkbox"
                     class="custom-checkbox"
                     [id]="internalResourceVM.internalResource.code"
                     [(ngModel)]="internalResourceVM.isSelected"
                     (change)="onSelect(internalResourceInput, internalResourceVM)"
                     binary="true" /><label [for]="internalResourceVM.internalResource.code"></label>
            </td>
            <td [class.isNotInActiveFilters]="internalResourceVM.isNotInActiveFilters"
                [matTooltip]="'TOOLTIP.INTERNAL_RESOURCE_NOT_IN_FILTER' | translate"
                matTooltipClass="pop-tooltip"
                [matTooltipDisabled]="!internalResourceVM.isNotInActiveFilters">{{
              internalResourceVM.internalResource.code }}</td>
            <td>{{ internalResourceVM.internalResource.description }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog #cd
                 appendTo="body"
                 styleClass="custom-alert">
  <p-footer>
    <button class="confirm-btn"
            type="button"
            pButton
            (click)="cd.accept()"
            translate="BUTTON.CONFIRM"></button>
    <button class="reject-btn"
            type="button"
            pButton
            (click)="cd.reject()"
            translate="BUTTON.CANCEL"></button>
  </p-footer>
</p-confirmDialog>
